import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=8a410c88&scoped=true"
import script from "./pickup.vue?vue&type=script&lang=js"
export * from "./pickup.vue?vue&type=script&lang=js"
import style0 from "./pickup.vue?vue&type=style&index=0&id=8a410c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a410c88",
  null
  
)

export default component.exports